import React from 'react';
import { SkeletonNavMenuItems } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/skeleton-nav-menu-items/main.tsx';
import { SideNavBody } from '@atlaskit/navigation-system/layout/side-nav';

export const SpaceAgentsSidebarSkeleton = (): React.JSX.Element => (
	<SideNavBody>
		<SkeletonNavMenuItems />
	</SideNavBody>
);

export default SpaceAgentsSidebarSkeleton;
